<h1 class="color-serfor">Usuarios</h1>


<form [formGroup] = "filtroForm"
  fxLayout="column"
	fxLayoutGap="2rem"
	fxLayoutGap.sm="1rem">


  <div
		fxLayout="column">


      <div
			fxLayout="row wrap"
      fxLayout
      fxLayoutAlign="left"
      fxLayoutGap="10px"
      fxLayoutGap.xs="0">
      
        <mat-form-field
          
        fxFlex="40%"
        >
            <mat-label class="col-form-label">Nombre</mat-label>
            <input matInput
              autocomplete="off"
              formControlName="nombre"
              id="nombre"
              name="nombre"
              maxlength="100"
              placeholder="Ingresa el usuario a buscar">
          </mat-form-field>
         
         
          <div class="button-flex-container" fxFlex="8%">
            <button 
              mat-raised-button 
              color="primary"
              (click) = "buscarUsuario()"
            >Buscar</button>
          </div>


          <div class="button-flex-container" fxFlex="15%">
            <button mat-raised-button color="primary" (click)="nuevoUsuario()">Nuevo Usuario</button>
          </div>

      </div>



    </div>


    



</form>

<div class="">
    <mat-table [dataSource]="dataSource" matSort>
     <ng-container matColumnDef="sqUsuario">
        <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
        <mat-cell *matCellDef="let usu"> {{usu.sqUsuario}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nombreCompleto">
        <mat-header-cell *matHeaderCellDef>Nombre</mat-header-cell>
        <mat-cell *matCellDef="let usu"> {{usu.nombreCompleto}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="correo">
        <mat-header-cell *matHeaderCellDef>Correo</mat-header-cell>
        <mat-cell *matCellDef="let usu"> {{usu.correo}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="estado">
        <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>

        <mat-cell *matCellDef="let usu;"> 
          
          <div *ngIf="usu.estado == '1'">
            
              <i class="material-icons pointer" (click)="cambiarEstado(usu, 0)">play_arrow</i>
            
          </div>
          <div *ngIf="usu.estado == '0'">
            
            
              <i class="material-icons pointer" (click)="cambiarEstado(usu, 1)">pause</i>
           

          </div>
          &nbsp;
          <div>
            <i class="material-icons pointer" (click)="editarUsuario(usu)">edit</i>
          </div>
          &nbsp;
          <div>
            <i class="material-icons pointer" (click)="cambiarEstado(usu, 2)">delete</i>
          </div>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="loading">
        <mat-footer-cell *matFooterCellDef colspan="6">
          En espera de la información.
        </mat-footer-cell>
      </ng-container>
      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="6">
          No existen registros.
        </mat-footer-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      
    </mat-table>
  </div>

  <div class="row">
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="25" showFirstLastButtons></mat-paginator>
  </div>

